import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import MessagesCards from "./MessagesCards"
import axios from "axios"
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import grey from "@material-ui/core/colors/grey"
import { Button, Container, Divider, Grid, TextField, Typography, MenuItem, Dialog, AppBar, Toolbar, IconButton, Slide, DialogContent } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { DateRangePickerComponent as DateRangePickerInternal } from 'materialui-daterange-picker';
import ClearIcon from '@material-ui/icons/Clear';
import { useHistory } from 'react-router-dom';
import Pagination from "../Pagination"
import ProgrssBar from '../ProgressBar'
import MuiPhoneNumber from "material-ui-phone-number";
import { DateRangePicker } from "materialui-daterange-picker";
import DirectionIcon from '@material-ui/icons/RepeatTwoTone';
import InputAdornment from '@material-ui/core/InputAdornment';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';



const useStyles = makeStyles((theme) => ({
    root: {
        width: "100vw",
        height: "100vh",
        backgroundColor: theme.palette.grey[300],
        paddingTop: theme.spacing(5)

    },
    calendarField: {
        cursor: 'pointer',
        '& .MuiOutlinedInput-root': {
            cursor: 'pointer',
            transition: 'background-color 120ms ease-in-out',
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    },
}))

// Stable transition component to prevent Dialog re-mount on every render
const TransitionUp = React.forwardRef(function TransitionUp(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Messages = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const isCompact = useMediaQuery('(max-width:1200px)');
    const isModalCal = isMobile || isCompact;
    document.body.style.backgroundColor = grey[300];
    const [loaded, setloaded] = useState(false)
    const [data, setData] = useState({
        info: {},
        next: {},
        results: []

    })
    
    const placeHolderDate = new Date()
    const todayUTCDateYMD = `${placeHolderDate.getUTCFullYear()}-${parseInt( placeHolderDate.getUTCMonth() + 1) > 9 ? parseInt(placeHolderDate.getUTCMonth() + 1) : "0" + parseInt(placeHolderDate.getUTCMonth() + 1)}-${placeHolderDate.getUTCDate() > 9 ? placeHolderDate.getUTCDate() : "0" + placeHolderDate.getUTCDate()}`
    const todayUTCDateMDY = `${placeHolderDate.getUTCMonth() + 1}/${placeHolderDate.getUTCDate()}/${placeHolderDate.getUTCFullYear()}`
    const [progress, setProgress] = useState(false)

    // Timezone selection
    const [timeZone, setTimeZone] = useState('UTC') // viewing timezone
    const [filterTimeZone, setFilterTimeZone] = useState('UTC') // filtering timezone
    const [drpHost, setDrpHost] = useState(null)
    const timeZoneOptions = useMemo(() => ([
        { label: 'UTC', value: 'UTC' },
        { label: 'PST (America/Los_Angeles)', value: 'America/Los_Angeles' },
        { label: 'MST (America/Denver)', value: 'America/Denver' },
        { label: 'CST (America/Chicago)', value: 'America/Chicago' },
        { label: 'EST (America/New_York)', value: 'America/New_York' },
        { label: 'Asia/Kolkata (India)', value: 'Asia/Kolkata' },
        { label: 'Asia/Shanghai (China)', value: 'Asia/Shanghai' },
        { label: 'Asia/Tokyo (Japan)', value: 'Asia/Tokyo' },
        { label: 'Asia/Singapore', value: 'Asia/Singapore' },
    ]), [])

    const [filter, setFilter] = useState({date:{"$gte":todayUTCDateYMD+"T00:00:00.000Z","$lte":todayUTCDateYMD+"T23:59:59.000Z"}})

    const [SimBoxesUnifiedSet, setSimBoxesUnifiedSet] = useState([])

    const [junk, setJunk] = useState("")

    const [page, setPage] = useState({ pageNumber: "1", limit: "24" })


    const [open, setOpen] = useState(false);
    const [mobileCalScale, setMobileCalScale] = useState(1);
    // Pending (unapplied) controls for timezone/time
    const [pendingTimeZone, setPendingTimeZone] = useState('UTC') // view
    const [pendingFilterTimeZone, setPendingFilterTimeZone] = useState('UTC') // filter
    const [pendingStartTime, setPendingStartTime] = useState('00:00:00')
    const [pendingEndTime, setPendingEndTime] = useState('23:59:59')

    const toggle = () => setOpen(!open);
    const defaultStartTime = '00:00:00'
    const defaultEndTime = '23:59:59'
    const [dateText, setDateText] = useState(`${todayUTCDateMDY} ${defaultStartTime} - ${todayUTCDateMDY} ${defaultEndTime}`)
    const [startTime, setStartTime] = useState(defaultStartTime)
    const [endTime, setEndTime] = useState(defaultEndTime)
    const canApply = useMemo(() => (
        pendingTimeZone !== timeZone ||
        pendingFilterTimeZone !== filterTimeZone ||
        pendingStartTime !== startTime ||
        pendingEndTime !== endTime
    ), [pendingTimeZone, pendingFilterTimeZone, pendingStartTime, pendingEndTime, timeZone, filterTimeZone, startTime, endTime])

    // Store the picked calendar range to recompute UTC bounds on timezone change
    const [selectedRange, setSelectedRange] = useState({ startDate: new Date(), endDate: new Date() })

    const [campaignList, setCampaignList] = useState([])

    // Utilities to handle timezone-safe conversions without extra deps
    const getTZFormatter = (tz) => new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
    })

    const getTimeZoneOffsetMs = (date, tz) => {
        const dtf = getTZFormatter(tz)
        const parts = dtf.formatToParts(date)
        const map = {}
        for (const { type, value } of parts) map[type] = value
        const asUTC = Date.UTC(Number(map.year), Number(map.month) - 1, Number(map.day), Number(map.hour), Number(map.minute), Number(map.second))
        return asUTC - date.getTime()
    }

    const zonedDateTimeToUtc = (y, m, d, h, mi, s, tz) => {
        const utcGuess = Date.UTC(y, m - 1, d, h, mi, s)
        const offset = getTimeZoneOffsetMs(new Date(utcGuess), tz)
        return new Date(utcGuess - offset)
    }

    const parseTime = (t, end = false) => {
        if (!t) return { h: end ? 23 : 0, m: end ? 59 : 0, s: end ? 59 : 0 }
        const parts = t.split(':').map(Number)
        const h = parts[0] || 0
        const m = parts[1] || 0
        const s = parts[2] != null ? parts[2] : (end ? 59 : 0)
        return { h, m, s }
    }

    // Abbreviation mapping for dynamic labels
    const tzAbbrMap = useMemo(() => ({
        'UTC': { '+00:00': 'Z' },
        'America/Los_Angeles': { '-08:00': 'PST', '-07:00': 'PDT' },
        'America/Denver': { '-07:00': 'MST', '-06:00': 'MDT' },
        'America/Chicago': { '-06:00': 'CST', '-05:00': 'CDT' },
        'America/New_York': { '-05:00': 'EST', '-04:00': 'EDT' },
        'Europe/London': { '+00:00': 'GMT', '+01:00': 'BST' },
        'Asia/Kolkata': { '+05:30': 'IST' },
        'Asia/Shanghai': { '+08:00': 'CST' },
        'Asia/Tokyo': { '+09:00': 'JST' },
        'Asia/Singapore': { '+08:00': 'SGT' },
    }), [])

    const getOffsetStr = (date, tz) => {
        const dtf = getTZFormatter(tz)
        const p2 = dtf.formatToParts(date)
        const mp = {}
        for (const { type, value } of p2) mp[type] = value
        const asUTC = Date.UTC(Number(mp.year), Number(mp.month) - 1, Number(mp.day), Number(mp.hour), Number(mp.minute), Number(mp.second))
        const offsetMs = asUTC - date.getTime()
        const totalMinutes = Math.round(offsetMs / 60000)
        const sign = totalMinutes >= 0 ? '+' : '-'
        const absMin = Math.abs(totalMinutes)
        const offH = String(Math.floor(absMin / 60)).padStart(2, '0')
        const offM = String(absMin % 60).padStart(2, '0')
        return `${sign}${offH}:${offM}`
    }

    const getCurrentAbbr = (tz, date = new Date()) => {
        const off = getOffsetStr(date, tz)
        const map = tzAbbrMap[tz]
        return map ? map[off] || null : null
    }

    // helpers above are used by calendar + time conversions

    // (rolled back) Quick ranges use library defaults (local timezone)

    const formatMDY = (y, m, d) => `${String(m).padStart(2,'0')}/${String(d).padStart(2,'0')}/${y}`
    const formatTimeHHMMSS = (t, end=false) => {
        if (!t) return end ? '23:59:59' : '00:00:00'
        const parts = t.split(':').map(Number)
        const h = isNaN(parts[0]) ? 0 : parts[0]
        const mi = isNaN(parts[1]) ? 0 : parts[1]
        const s = parts.length > 2 && !isNaN(parts[2]) ? parts[2] : (end ? 59 : 0)
        const pad = (n) => String(n).padStart(2,'0')
        return `${pad(h)}:${pad(mi)}:${pad(s)}`
    }
    const formatRangeText = (y1,m1,d1,y2,m2,d2, st, et) => {
        const left = `${formatMDY(y1,m1,d1)} ${formatTimeHHMMSS(st,false)}`
        const right = `${formatMDY(y2,m2,d2)} ${formatTimeHHMMSS(et,true)}`
        return `${left} - ${right}`
    }

    // Show clear-X next to note only when filter is from zone or time
    const hasTzOrTimeFilter = useMemo(() => {
        return timeZone !== 'UTC' || filterTimeZone !== 'UTC' || startTime !== defaultStartTime || endTime !== defaultEndTime
    }, [timeZone, filterTimeZone, startTime, endTime])

    const clearAllFilters = () => {
        const now = new Date()
        const y = now.getUTCFullYear(); const m = now.getUTCMonth() + 1; const d = now.getUTCDate()
        const newDateText = formatRangeText(y, m, d, y, m, d, defaultStartTime, defaultEndTime)
        setTimeZone('UTC')
        setFilterTimeZone('UTC')
        setStartTime(defaultStartTime)
        setEndTime(defaultEndTime)
        setJunk("")
        setFilter({ date: { $gte: `${todayUTCDateYMD}T00:00:00.000Z`, $lte: `${todayUTCDateYMD}T23:59:59.000Z` } })
        setPage({ ...page, pageNumber: '1' })
        setSelectedRange({ startDate: new Date(y, m - 1, d), endDate: new Date(y, m - 1, d) })
        setDateText(newDateText)
    }

    const calFunc = (range) => {
        toggle()
        const { startDate, endDate } = range
        setSelectedRange({ startDate, endDate })

        // Build UTC bounds from selected TZ, but use the numeric day values picked in the calendar
        const y1 = new Date(startDate).getFullYear(); const m1 = new Date(startDate).getMonth() + 1; const d1 = new Date(startDate).getDate()
        const y2 = new Date(endDate).getFullYear();   const m2 = new Date(endDate).getMonth() + 1;   const d2 = new Date(endDate).getDate()
        const tzUsed = filterTimeZone || 'UTC'
        const st = parseTime(startTime, false)
        const et = parseTime(endTime, true)
        const startDateISO = zonedDateTimeToUtc(y1, m1, d1, st.h, st.m, st.s, tzUsed).toISOString()
        const endDateISO = zonedDateTimeToUtc(y2, m2, d2, et.h, et.m, et.s, tzUsed).toISOString()
        // const startDateLocal = new Date(startDate).toLocaleDateString()

        // console.log(startDateISO, endDateISO)

        let date = { $gte: startDateISO, $lte: endDateISO }
        //  date = { date }
        //    const dataString = data.toString()
        //    console.log(data)
        setFilter({ ...filter, date })
        // Reset pagination to first page when calendar changes
        setPage({ ...page, pageNumber: "1" })

        // Display the picked days + times
        setDateText(formatRangeText(y1,m1,d1,y2,m2,d2, startTime, endTime))
        // console.log(range)
    }

    const clearCalc = () => {
        setDateText("")
        filter.date = undefined
        setFilter({ ...filter })
        setPage({ ...page, pageNumber: "1" })
        setStartTime(defaultStartTime)
        setEndTime(defaultEndTime)
        toggle()
    }

    // Recompute date filter if timezone changes while a range is selected
    useEffect(() => {
        if (!selectedRange || !selectedRange.startDate || !selectedRange.endDate) return
        if (!filter.date) return
        // Preserve the numeric picked days when timezone changes
        const y1 = selectedRange.startDate.getFullYear(); const m1 = selectedRange.startDate.getMonth() + 1; const d1 = selectedRange.startDate.getDate()
        const y2 = selectedRange.endDate.getFullYear();   const m2 = selectedRange.endDate.getMonth() + 1;   const d2 = selectedRange.endDate.getDate()
        const tzUsed = filterTimeZone || 'UTC'
        const st = parseTime(startTime, false)
        const et = parseTime(endTime, true)
        const startDateISO = zonedDateTimeToUtc(y1, m1, d1, st.h, st.m, st.s, tzUsed).toISOString()
        const endDateISO = zonedDateTimeToUtc(y2, m2, d2, et.h, et.m, et.s, tzUsed).toISOString()
        setFilter({ ...filter, date: { $gte: startDateISO, $lte: endDateISO } })
        // Reset to first page on timezone/filter mode change
        setPage({ ...page, pageNumber: "1" })
        setDateText(formatRangeText(y1,m1,d1,y2,m2,d2, startTime, endTime))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeZone, filterTimeZone])

    // Recompute when only time changes
    useEffect(() => {
        if (!selectedRange || !selectedRange.startDate || !selectedRange.endDate) return
        if (!filter.date) return
        const y1 = selectedRange.startDate.getFullYear(); const m1 = selectedRange.startDate.getMonth() + 1; const d1 = selectedRange.startDate.getDate()
        const y2 = selectedRange.endDate.getFullYear();   const m2 = selectedRange.endDate.getMonth() + 1;   const d2 = selectedRange.endDate.getDate()
        const tzUsed = filterTimeZone || 'UTC'
        const st = parseTime(startTime, false)
        const et = parseTime(endTime, true)
        const startDateISO = zonedDateTimeToUtc(y1, m1, d1, st.h, st.m, st.s, tzUsed).toISOString()
        const endDateISO = zonedDateTimeToUtc(y2, m2, d2, et.h, et.m, et.s, tzUsed).toISOString()
        setFilter({ ...filter, date: { $gte: startDateISO, $lte: endDateISO } })
        setPage({ ...page, pageNumber: "1" })
        setDateText(formatRangeText(y1,m1,d1,y2,m2,d2, startTime, endTime))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTime, endTime])

    // Find the DateRangePicker wrapper element after it opens so portal mounts reliably
    useEffect(() => {
        if (!open) return;
        // initialize pending controls from committed values
        setPendingTimeZone(timeZone)
        setPendingFilterTimeZone(filterTimeZone)
        setPendingStartTime(startTime)
        setPendingEndTime(endTime)

        let raf = 0
        const assignHost = () => {
            const host = document.querySelector('.gmp-drp-wrapper')
            if (host) {
                // @ts-ignore
                setDrpHost(host)
            } else {
                raf = window.requestAnimationFrame(assignHost)
            }
        }
        if (!isModalCal) {
            raf = window.requestAnimationFrame(assignHost)
        }

        // compute mobile calendar scale to fit two-month view
        let computeScale
        if (isModalCal) {
            computeScale = () => {
                const available = Math.max(300, window.innerWidth - 32); // padding
                const baseWidth = 720; // approx width needed for 2 months
                const s = Math.min(1, available / baseWidth);
                const minScale = 0.85; // slightly smaller on small devices
                setMobileCalScale(Math.max(minScale, s));
            }
            computeScale();
            window.addEventListener('resize', computeScale);
        }
        return () => {
            if (raf) window.cancelAnimationFrame(raf)
            if (computeScale) window.removeEventListener('resize', computeScale);
            setDrpHost(null)
        }
    }, [open, isModalCal, timeZone, filterTimeZone, startTime, endTime])

    const applyTzTimeChanges = () => {
        // Commit pending values and close calendar; effects will recompute filter
        setTimeZone(pendingTimeZone)
        const finalFilterTz = (pendingFilterTimeZone === '__SAME_AS_VIEW__') ? pendingTimeZone : pendingFilterTimeZone
        setFilterTimeZone(finalFilterTz || 'UTC')
        setStartTime(pendingStartTime)
        setEndTime(pendingEndTime)
        toggle()
    }


    const check = () => {
        if (filter.type === "MT") {
            setFilter({ ...filter, type: "MO" })
            setPage({ ...page, pageNumber: "" })
        } else if (filter.type === "MO") {

            setJunk("junks-mt")
            filter.type = undefined
            setFilter({ ...filter, text: { $regex: "Free Msg: Unable to send message" } })
            setPage({ ...page, pageNumber: "" })
        } else if (junk === "junks-mt") {
            setJunk("junks-mo")
            filter.type = undefined
            filter.text = undefined
            setFilter({ ...filter })
            setPage({ ...page, pageNumber: "" })

        } else if (junk === "junks-mo") {
            setJunk("")
            filter.type = undefined
            filter.text = undefined
            setFilter({ ...filter })
            setPage({ ...page, pageNumber: "" })
        } else {
            setFilter({ ...filter, type: "MT" })
            setPage({ ...page, pageNumber: "" })
        }
    }



    function handlePage(val) {
        setPage({ ...page, pageNumber: val })
    }

    function handleLimit(val) {
        if (page.limit !== val) {
            setPage({ ...page, limit: val })
        }
    }


    const phoneFilter = (val) => {
        val = val.replace(" ", "")
        val = val.replace("+1", "1").replace(" ", "").replace("-", "").replace("(", "").replace(")", "")
        // console.log(val)
        if (val !== "1") {
            setPage({ ...page, pageNumber: "" })
            setFilter({ ...filter, phone: val })
            // console.log(filter)
        } else {
            filter.phone = undefined
            setFilter({ ...filter })
            // console.log(filter)
        }

    }

    const simboxFilter = (event) => {
        const { value } = event.target
        setPage({ ...page, pageNumber: "" })
        if (value) {

            setFilter({ ...filter, $or: [{ "smsSendStatus.simBoxPort": value }, { "smsReceiveStatus.simBoxPort": value }] })
        } else {
            filter.$or = undefined
            setFilter({ ...filter })
        }
        // console.log(value)
    }

    const simPortFilter = (event) => {
        // Allow only digits, max 2 chars
        let { value } = event.target
        value = String(value || '').replace(/\D/g, '').slice(0, 2)
        setPage({ ...page, pageNumber: "" })
        if (value) { setFilter({ ...filter, port: value }) }
        else { filter.port = undefined; setFilter({ ...filter }) }
    }

    const subPortFilter = (event) => {
        const { value } = event.target
        setPage({ ...page, pageNumber: "" })
        if (value) { setFilter({ ...filter, subPort: value }) }
        else { filter.subPort = undefined; setFilter({ ...filter }) }
    }

    const guidFilter = (event) => {
        setPage({ ...page, pageNumber: "" })
        const { value } = event.target
        if (value) { setFilter({ ...filter, _id: value }) }
        else { filter._id = undefined; setFilter({ ...filter }) }
    }


    const status = (event) => {
        setPage({ ...page, pageNumber: "" })



        const { value } = event.target

        if (value === "delivered") {
            filter["smsSendStatus.status"] = undefined
            filter["smsSendStatus"] = undefined
            filter["smsReceiveStatus"] = undefined
            setFilter({ ...filter, "smsSendStatus.dlrStatus": value })
        }
        else if (value === "failed") {
            filter["smsSendStatus.status"] = undefined
            filter["smsSendStatus"] = undefined
            filter["smsReceiveStatus"] = undefined
            setFilter({ ...filter, "smsSendStatus.dlrStatus": value })
        }
        else if (value === "Success") {
            filter["smsSendStatus.dlrStatus"] = undefined
            filter["smsSendStatus"] = undefined
            filter["smsReceiveStatus"] = undefined
            setFilter({ ...filter, "smsSendStatus.status": value, "smsSendStatus.dlrStatus": null })
        }
        else if (value === "Reject") {
            filter["smsSendStatus.dlrStatus"] = undefined
            filter["smsSendStatus"] = undefined
            filter["smsReceiveStatus"] = undefined
            setFilter({ ...filter, "smsSendStatus.status": value })
        }
        else if (value === "internal error") {
            filter["smsSendStatus.status"] = undefined
            filter["smsSendStatus.dlrStatus"] = undefined
            setFilter({ ...filter, "smsSendStatus": null, "smsReceiveStatus": null })
        } else {
            filter["smsSendStatus.status"] = undefined
            filter["smsSendStatus"] = undefined
            filter["smsReceiveStatus"] = undefined
            filter["smsSendStatus.dlrStatus"] = undefined
            setFilter({ ...filter })
        }
    }

    // const filter = {
    //     // "_id" : "608502493a0c4d391d753a3d",
    //     type : "MO"
    // }

    const carrierFilter = (event) => {
        setPage({ ...page, pageNumber: "" })
        const { value } = event.target
        if (value) {
            if (value === "") {
                filter.carrier = undefined
                setFilter({ ...filter })
            } else {
                setFilter({ ...filter, carrier: value })
            }
        } else {
            filter.carrier = undefined
            setFilter({ ...filter })
        }
    }

    const filterAgentMT = (event) => {
        setPage({ ...page, pageNumber: "" })
        const { value } = event.target
        if (value) {
            if (value === "") {
                filter.campaignID = undefined
                setFilter({ ...filter })
            } else {
                if (value === "hide") {
                    setFilter({ ...filter, campaignID: { $ne: "AGENT-MT" } })
                }
                if (value === "show") {
                    setFilter({ ...filter, campaignID: "AGENT-MT" })
                }
            }
        } else {
            filter.campaignID = undefined
            setFilter({ ...filter })
        }
    }

    const campaignFilter = (event) => {
        setPage({ ...page, pageNumber: "" })
        const { value } = event.target
        if (value) {
            if (value === "") {
                filter.campaign = undefined
                setFilter({ ...filter })
            } else {
                setFilter({ ...filter, campaign: value })
            }
        } else {
            filter.campaign = undefined
            setFilter({ ...filter })
        }
    }
    



    const history = useHistory()

    useEffect(() => {

        document.title = "GMP - Please Wait..."
        let source = axios.CancelToken.source()
        const getCampaignsMenu = async () => {

            const headers = {
                withCredentials: true
            }
            try {
                const campaignListMenu = await axios.get(process.env.REACT_APP_API_URL + "/campaign",  headers )
                setCampaignList(campaignListMenu.data.results.map((val) => val.campaign))                
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.info("Last Request Was Cancelled")
                } else {
                    if (error.response.status === 401) {
                        history.push("/")
                    }
                    // console.log(error)
                    setProgress(false)
                }
            }
        }
        getCampaignsMenu()

        return () => {
            source.cancel()
        }

    }, [history, filter, page])



    useEffect(() => {

        document.title = "GMP - Please Wait..."
        let source = axios.CancelToken.source()
        const getData = async () => {

            // const headers = {
            //     withCredentials: true
            // }
            try {
                // const user = localStorage.getItem("user");
                setProgress(true)

                const getDataResult = await axios.post(process.env.REACT_APP_API_URL+ `/reports/${junk.split("-")[0]}?page=${page.pageNumber}&limit=${page.limit}&sort=date&order=desc`, filter, { cancelToken: source.token, withCredentials: true })
                // console.log(getDataResult)

                setData({
                    info: getDataResult.data.info,
                    next: getDataResult.data.next,
                    results: getDataResult.data.results

                })
                setProgress(false)
                setloaded(true)
                document.title = "GMP - Messages"
                // setloaded(true)
                // console.log(getDataResult)

            } catch (error) {
                if (axios.isCancel(error)) {
                    console.info("Last Request Was Cancelled")
                } else {
                    if (error.response.status === 401) {
                        history.push("/")
                    }
                    // console.log(error)
                    setProgress(false)
                    setData({
                        info: { "counts": 0 }
                    })
                }
            }
        }
        getData()



        // setInterval(() => {
        //     getData()
        // }, 30000);

        return () => {
            // console.log("unmount")
            source.cancel()

            // console.clear()
        }

    }, [history, filter, page, junk])



    useEffect(() => {

        if(!loaded) return 
        let source = axios.CancelToken.source()
        const boxes = async () => {
            // const headers = {
            //     withCredentials: true
            // }


            try {

                const getSimBoxesUnifiedSetList = await axios.get(process.env.REACT_APP_API_URL + "/gateway/simboxes-unified", { cancelToken: source.token, withCredentials: true })
                setSimBoxesUnifiedSet(getSimBoxesUnifiedSetList.data.SimBoxesUnifiedSet)

            } catch (error) {
                if (axios.isCancel(error)) {
                    console.info("Last Request Was Cancelled")
                } else {
                    if (error.response.status === 401) {
                        history.push("/")
                    }
                }
            }
        }

        boxes()

        return () => {
            source.cancel()
        }

    }, [history,loaded])


    const classes = useStyles();
    if (loaded) {

        return (
            <React.Fragment>
                { progress && <ProgrssBar />}
                <br />

                <Grid container justify="center" spacing={1}>

                    <Grid item style={{ display: "flex" }}>

                        <Button color="primary" onClick={() => check()} variant="contained" startIcon={<DirectionIcon />}>Direction {filter.type || junk || "MT / MO"}

                        </Button>
                    </Grid>

                    <Grid item>
                        <TextField onClick={toggle}
                            variant="outlined"
                            label="Calendar"
                            placeholder="Date Range"
                            style={{ width: 'min(35ch, 95vw)', cursor: 'pointer' }}
                            className={classes.calendarField}
                            inputProps={{ readOnly: true, style: { cursor: 'pointer' } }}
                            onChange={clearCalc} value={dateText} />
                    </Grid>
                    

                    {/* Timezone control moved into calendar overlay */}


                    <Grid item>
                        &nbsp;  <MuiPhoneNumber
                            variant="outlined"
                            name="phone"
                            id="phone"
                            label="Phone Number"
                            data-cy="user-phone"
                            defaultCountry={"us"}
                            countryCodeEditable={false}
                            value={filter.phone}
                            onChange={phoneFilter}
                        />
                    </Grid>

                    <Grid item>
                        &nbsp;  <TextField
                            select
                            variant="outlined"
                            label="SimBox Port"
                            placeholder="MT/MO Machine Port"
                            style={{ width: "132px" }}
                            SelectProps={{
                                native: true,
                            }}
                            onChange={simboxFilter}>

                            <option value="">

                            </option>

                            {
                                SimBoxesUnifiedSet.map((val) => {
                                    return <option key={val} value={val}>{val}</option>
                                })
                            }

                            {/* <option value="8012">
                                8012
                </option>
                            <option value="8013">
                                8013
                </option>
                            <option value="8014">
                                8014
                </option>
                            <option value="8015">
                                8015
                </option>
                            <option value="8016">
                                8016
                </option> */}
                        </TextField>
                    </Grid>

                    <Grid item>
                        &nbsp;  <TextField
                            variant="outlined"
                            label="SIM Port"
                            placeholder="20"
                            style={{ width: "120px" }}
                            className="sim-port-field"
                            value={filter.port || ''}
                            onChange={simPortFilter}
                            onKeyDown={(e) => {
                                const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab']
                                if (!/\d/.test(e.key) && !allowed.includes(e.key)) {
                                    e.preventDefault()
                                }
                            }}
                            onPaste={(e) => {
                                const pasted = (e.clipboardData || window.clipboardData).getData('text')
                                if (/\D/.test(pasted)) e.preventDefault()
                            }}
                            inputProps={{ maxLength: 2, inputMode: 'numeric', pattern: '[0-9]*' }}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" style={{ paddingRight: 6 }}>
                                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                            <span style={{ width: 4, height: 4, borderRadius: '50%', background: '#424242', display: 'inline-block', margin: '0 4px' }} />
                                            <select onChange={subPortFilter}
                                                style={{
                                                    border: 'none',
                                                    background: 'transparent',
                                                    outline: 'none',
                                                    WebkitAppearance: 'none',
                                                    MozAppearance: 'none',
                                                    appearance: 'none',
                                                    padding: '14px 12px 14px 6px',
                                                    width: 40,
                                                    fontSize: 'inherit',
                                                    lineHeight: 'inherit',
                                                    color: 'inherit',
                                                    cursor: 'pointer',
                                                    borderLeft: 'none'
                                                }}
                                            >
                                                <option value=""></option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                            </select>
                                            <ArrowDropDownIcon style={{ position: 'absolute', right: 2, pointerEvents: 'none', fontSize: 20, opacity: 0.6 }} />
                                        </div>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>

                    

                    <Grid item>
                        &nbsp;  <TextField
                            style={{ width: "245px" }}
                            variant="outlined"
                            label="Transaction GUID / ObjectID"
                            placeholder="60a556285a0ea90015d6141f"

                            onChange={guidFilter}
                        />
                    </Grid>

                    <Grid item>
                        &nbsp;  <TextField
                            select
                            variant="outlined"
                            label="Message Status"
                            placeholder="MT/MO Status"
                            style={{ width: "180px" }}
                            SelectProps={{
                                native: true,
                            }}
                            onChange={status}>

                            <option value="">

                            </option>

                            <option value="delivered">
                                Delivered
                </option>
                            <option value="failed">
                                Failed
                </option>
                            <option value="Success">
                                Success
                </option>
                            <option value="Reject">
                                Reject
                </option>
                            <option value="internal error">
                                Internal Error
                </option>
                        </TextField>
                    </Grid>

                <Divider />

                <Grid item>
                        &nbsp;  <TextField
                            select
                            variant="outlined"
                            label="Carrier"
                            placeholder="Carrier Filter"
                            style={{ width: "180px" }}
                            SelectProps={{
                                native: true,
                            }}
                            onChange={carrierFilter}>

                            <option value="">

                            </option>

                            <option value="VZW">
                                Verizon
                            </option>
                            <option value="ATT">
                                AT&T
                            </option>
                            <option value="TMO">
                                TMobile
                            </option>
                            <option value="SPRINT">
                                Sprint
                            </option>
                            <option value="ALLOTHER">
                            ALLOTHER
                            </option>
                        </TextField>
                    </Grid>

                    <Grid item>
                        &nbsp;  <TextField
                            select
                            variant="outlined"
                            label="Campaign"
                            placeholder="Filter Campaign"
                            // style={{ width: "220px" }}
                            SelectProps={{
                                native: true,
                            }}
                            value={filter.campaign}
                            onChange={campaignFilter}>

                            <option value="">

                            </option>

                            {
                                campaignList.map((val) => {
                                    return val==="NULL" ? <option key={val} value={val}>{`DEFAULT(${val})`}</option> : <option key={val} value={val}>{val}</option>
                                }
                                )
                            }


                        </TextField>
                    </Grid>

                    <Grid item>
                        &nbsp;  <TextField
                            select
                            variant="outlined"
                            label="Agent-MT"
                            placeholder="Filter Agent-MT"
                            style={{ width: "180px" }}
                            SelectProps={{
                                native: true,
                            }}
                            onChange={filterAgentMT}>

                            <option value="">

                            </option>

                            <option value="hide">
                                Hide
                            </option>
                            <option value="show">
                                Show
                            </option>


                        </TextField>
                    </Grid>
                    


                </Grid>

                <br />

                {open &&
                    <Grid item>
                        <br />
                        <br />
                        <br />

                        {!isModalCal && (
                            <DateRangePicker
                                wrapperClassName="gmp-drp-wrapper"
                                open={open}
                                toggle={toggle}
                                onChange={(range) => calFunc(range)}
                            />
                        )}

                        {/* Render timezone selectors inside the panel via portal */}
                        {open && !isModalCal && drpHost && (
                            ReactDOM.createPortal(
                                <div style={{ background: 'transparent', marginTop: 12, marginLeft: 12 }}>
                                    <Box boxShadow={0} borderRadius={8} style={{ background: 'white', marginBottom: 16, border: `1px solid ${grey[400]}` }}>
                                        <Typography variant="subtitle2" color="textSecondary" style={{ fontWeight: 600, padding: '8px 12px 0' }}>
                                            Timezone
                                        </Typography>
                                        <Grid container spacing={1} style={{ padding: 12 }}>
                                            <Grid item>
                                            <TextField
                                                select
                                                variant="outlined"
                                                label="Filter In"
                                                placeholder="Filter timezone"
                                                style={{ width: 260, background: 'white' }}
                                                value={pendingFilterTimeZone}
                                                onChange={(e) => setPendingFilterTimeZone(e.target.value)}
                                            >
                                                <MenuItem value="__SAME_AS_VIEW__">Same as View</MenuItem>
                                                {timeZoneOptions.map((tz) => {
                                                    const refDate = (selectedRange && selectedRange.startDate) ? selectedRange.startDate : new Date()
                                                    const current = getCurrentAbbr(tz.value, refDate)
                                                    const abbrs = tzAbbrMap[tz.value] ? Array.from(new Set(Object.values(tzAbbrMap[tz.value]))) : []
                                                    const others = abbrs.filter(a => a !== current)
                                                    return (
                                                        <MenuItem key={tz.value} value={tz.value}>
                                                            <span>
                                                                {current ? <strong>{current}</strong> : tz.label}
                                                                {others.length > 0 && others.map((o, idx) => (
                                                                    <Typography key={o} variant="body2" color="textSecondary" component="span">{`${idx===0 && current? ' / ' : ' / '}${o}`}</Typography>
                                                                ))}
                                                                <Typography variant="body2" color="textSecondary" component="span">{` (${tz.value})`}</Typography>
                                                            </span>
                                                        </MenuItem>
                                                    )
                                                })}
                                            </TextField>
                                            </Grid>
                                            <Grid item>
                                            <TextField
                                                select
                                                variant="outlined"
                                                label="View In"
                                                placeholder="View timezone"
                                                style={{ width: 260, background: 'white' }}
                                                value={pendingTimeZone}
                                                onChange={(e) => setPendingTimeZone(e.target.value)}
                                            >
                                                {timeZoneOptions.map((tz) => {
                                                    const refDate = (selectedRange && selectedRange.startDate) ? selectedRange.startDate : new Date()
                                                    const current = getCurrentAbbr(tz.value, refDate)
                                                    const abbrs = tzAbbrMap[tz.value] ? Array.from(new Set(Object.values(tzAbbrMap[tz.value]))) : []
                                                    const others = abbrs.filter(a => a !== current)
                                                    return (
                                                        <MenuItem key={tz.value} value={tz.value}>
                                                            <span>
                                                                {current ? <strong>{current}</strong> : tz.label}
                                                                {others.length > 0 && others.map((o, idx) => (
                                                                    <Typography key={o} variant="body2" color="textSecondary" component="span">{`${idx===0 && current? ' / ' : ' / '}${o}`}</Typography>
                                                                ))}
                                                                <Typography variant="body2" color="textSecondary" component="span">{` (${tz.value})`}</Typography>
                                                            </span>
                                                        </MenuItem>
                                                    )
                                                })}
                                            </TextField>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    
                                    <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                                        <TextField
                                            type="time"
                                            label="Start Time"
                                            variant="outlined"
                                            value={pendingStartTime}
                                            onChange={(e) => setPendingStartTime(e.target.value)}
                                            inputProps={{ step: 1 }}
                                            style={{ width: 160, background: 'white', marginRight: 8 }}
                                        />
                                        <TextField
                                            type="time"
                                            label="End Time"
                                            variant="outlined"
                                            value={pendingEndTime}
                                            onChange={(e) => setPendingEndTime(e.target.value)}
                                            inputProps={{ step: 1 }}
                                            style={{ width: 160, background: 'white' }}
                                        />
                                    </div>
                                    <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                                        <Button size="medium" variant="contained" color="primary" startIcon={<DoneIcon />} onClick={applyTzTimeChanges} disabled={!canApply} style={{ minWidth: 140 }}>
                                            Apply
                                        </Button>
                                        <Button size="medium" variant="outlined" startIcon={<CloseIcon />} onClick={toggle} style={{ minWidth: 140 }}>
                                            Cancel
                                        </Button>
                                    </div>
                                    <div style={{ marginTop: 8 }}>
                                        <Button size="small" variant="outlined" color="secondary" startIcon={<ClearIcon />} onClick={() => { clearAllFilters(); toggle(); }}>
                                            Reset to default
                                        </Button>
                                    </div>
                                </div>,
                                drpHost
                            )
                        )}

                        {/* Mobile full-screen modal */}
                        {open && isModalCal && (
                            <Dialog fullScreen open={open} onClose={toggle} TransitionComponent={TransitionUp}>
                                <AppBar position="relative" color="primary">
                                    <Toolbar>
                                        <IconButton edge="start" color="inherit" onClick={toggle} aria-label="close">
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography variant="h6" style={{ marginLeft: 8, flex: 1 }}>
                                            Select Range & Timezone
                                        </Typography>
                                    </Toolbar>
                                </AppBar>
                                <DialogContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Box boxShadow={0} borderRadius={8} style={{ background: 'white', marginBottom: 16, border: `1px solid ${grey[400]}` }}>
                                                <Typography variant="subtitle2" color="textSecondary" style={{ fontWeight: 600, padding: '8px 12px 0' }}>
                                                    Timezone
                                                </Typography>
                                                <Grid container spacing={2} style={{ padding: 12 }}>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            select
                                                            variant="outlined"
                                                label="Filter In"
                                                            placeholder="Filter timezone"
                                                            fullWidth
                                                            value={pendingFilterTimeZone}
                                                            onChange={(e) => setPendingFilterTimeZone(e.target.value)}
                                                        >
                                                            <MenuItem value="__SAME_AS_VIEW__">Same as View</MenuItem>
                                                            {timeZoneOptions.map((tz) => {
                                                                const refDate = (selectedRange && selectedRange.startDate) ? selectedRange.startDate : new Date()
                                                                const current = getCurrentAbbr(tz.value, refDate)
                                                                const abbrs = tzAbbrMap[tz.value] ? Array.from(new Set(Object.values(tzAbbrMap[tz.value]))) : []
                                                                const others = abbrs.filter(a => a !== current)
                                                                return (
                                                                    <MenuItem key={tz.value} value={tz.value}>
                                                                        <span>
                                                                            {current ? <strong>{current}</strong> : tz.label}
                                                                            {others.length > 0 && others.map((o, idx) => (
                                                                                <Typography key={o} variant="body2" color="textSecondary" component="span">{`${idx===0 && current? ' / ' : ' / '}${o}`}</Typography>
                                                                            ))}
                                                                            <Typography variant="body2" color="textSecondary" component="span">{` (${tz.value})`}</Typography>
                                                                        </span>
                                                                    </MenuItem>
                                                                )
                                                            })}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            select
                                                            variant="outlined"
                                                label="View In"
                                                            placeholder="View timezone"
                                                            fullWidth
                                                            value={pendingTimeZone}
                                                            onChange={(e) => setPendingTimeZone(e.target.value)}
                                                        >
                                                            {timeZoneOptions.map((tz) => {
                                                                const refDate = (selectedRange && selectedRange.startDate) ? selectedRange.startDate : new Date()
                                                                const current = getCurrentAbbr(tz.value, refDate)
                                                                const abbrs = tzAbbrMap[tz.value] ? Array.from(new Set(Object.values(tzAbbrMap[tz.value]))) : []
                                                                const others = abbrs.filter(a => a !== current)
                                                                return (
                                                                    <MenuItem key={tz.value} value={tz.value}>
                                                                        <span>
                                                                            {current ? <strong>{current}</strong> : tz.label}
                                                                            {others.length > 0 && others.map((o, idx) => (
                                                                                <Typography key={o} variant="body2" color="textSecondary" component="span">{`${idx===0 && current? ' / ' : ' / '}${o}`}</Typography>
                                                                            ))}
                                                                            <Typography variant="body2" color="textSecondary" component="span">{` (${tz.value})`}</Typography>
                                                                        </span>
                                                                    </MenuItem>
                                                                )
                                                            })}
                                                        </TextField>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={6} style={{ marginTop: 8 }}>
                                            <TextField
                                                type="time"
                                                label="Start Time"
                                                variant="outlined"
                                                fullWidth
                                                value={pendingStartTime}
                                                onChange={(e) => setPendingStartTime(e.target.value)}
                                                inputProps={{ step: 1 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} style={{ marginTop: 8 }}>
                                            <TextField
                                                type="time"
                                                label="End Time"
                                                variant="outlined"
                                                fullWidth
                                                value={pendingEndTime}
                                                onChange={(e) => setPendingEndTime(e.target.value)}
                                                inputProps={{ step: 1 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>
                                                    <Button fullWidth size="medium" variant="outlined" startIcon={<CloseIcon />} onClick={toggle}>
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Button fullWidth size="medium" variant="contained" color="primary" startIcon={<DoneIcon />} onClick={applyTzTimeChanges} disabled={!canApply}>
                                                        Apply
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Button fullWidth size="small" variant="outlined" color="secondary" startIcon={<ClearIcon />} onClick={() => { clearAllFilters(); toggle(); }}>
                                                        Reset to default
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden', display: 'flex', justifyContent: 'center' }}>
                                                <div style={{ width: 720, transform: `scale(${mobileCalScale})`, transformOrigin: 'top center' }}>
                                                    <DateRangePickerInternal
                                                        open={true}
                                                        definedRanges={[]}
                                                        onChange={(range) => calFunc(range)}
                                                    />
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </DialogContent>
                            </Dialog>
                        )}

                    </Grid>
                }
                <Divider />




                {(data.info.counts > 0) && (
                    <>
                        <Pagination
                          showHead="true"
                          pages={data.info.pages}
                          totalCounts={data.info.counts}
                          handlePage={handlePage}
                          handleLimit={handleLimit}
                          currentLimit={page.limit}
                          currentPage={data.info.currentPageNumber}
                          noteText={( () => {
                            const refDate = (selectedRange && selectedRange.startDate) ? selectedRange.startDate : new Date()
                            const viewAbbr = getCurrentAbbr(timeZone, refDate)
                            const viewOff = getOffsetStr(refDate, timeZone)
                            const viewElegant = timeZone === 'UTC' ? 'UTC (Z)' : `${viewAbbr || ''}${viewAbbr ? ' ' : ''}(${timeZone}, ${viewOff})`
                            const tzUsed = filterTimeZone || 'UTC'
                            if (tzUsed === 'UTC' && timeZone === 'UTC') return 'Viewing & filtering in UTC (Z)'
                            const filtAbbr = getCurrentAbbr(tzUsed, refDate)
                            const filtOff = getOffsetStr(refDate, tzUsed)
                            const filtElegant = tzUsed === 'UTC' ? 'UTC (Z)' : `${filtAbbr || ''}${filtAbbr ? ' ' : ''}(${tzUsed}, ${filtOff})`
                            if (tzUsed === timeZone) return `Viewing & filtering in ${viewElegant}`
                            return `Viewing in ${viewElegant}; filtering in ${filtElegant}`
                          })()}
                          noteOnClear={hasTzOrTimeFilter ? clearAllFilters : undefined}
                        />
                    </>
                )}
                <Container className={classes.root}>
                    {(data.info.counts > 0) ?
                        <React.Fragment>
                            <Grid container spacing={2}>
                                {
                                    data.results.map((val) => {
                                        // console.log(val.smsSendStatus)
                                        return <MessagesCards
                                            key={val._id}
                                            dataId={val._id}
                                            dateTime={val.date}
                                            timeZone={timeZone}
                                            msgType={(val.type !== "MO-JUNK") ? val.type : "JNK"}
                                            carrier={val.carrier}
                                            phone={val.phone}
                                            text={val.text}
                                            simBoxPort={val.smsSendStatus ? val.smsSendStatus.simBoxPort : "Error" && val.smsReceiveStatus ? val.smsReceiveStatus.simBoxPort : "Error"}
                                            port={val.port}
                                            subPort={(
                                                (typeof val.subPort !== 'undefined' && val.subPort !== null) ? val.subPort :
                                                (val.smsSendStatus && typeof val.smsSendStatus.subPort !== 'undefined') ? val.smsSendStatus.subPort :
                                                (val.smsReceiveStatus && typeof val.smsReceiveStatus.subPort !== 'undefined') ? val.smsReceiveStatus.subPort :
                                                undefined
                                            )}
                                            dlrStatus={val.smsSendStatus ? val.smsSendStatus.dlrStatus || val.smsSendStatus.status : val.smsReceiveStatus ? "Received" : "Internal Error"}
                                            campaign={val.campaign}
                                            campaignID={val.campaignID}
                                            leadID={val.leadID}
                                        />

                                    })

                                }
                            </Grid>
                            <Pagination pages={data.info.pages} showHead="false" totalCounts={data.info.counts} handlePage={handlePage} handleLimit={handleLimit} currentLimit={page.limit} currentPage={data.info.currentPageNumber} />
                            <br />
                            <br />
                            <br />
                            <br />
                        </React.Fragment>
                        :
                        <h1><center>No Records Found...</center></h1>
                    }
                </Container>
            </React.Fragment>
        );


    } else {


        return (
            <React.Fragment>
                <ProgrssBar />
                <h1>Please Wait...</h1>
            </React.Fragment>
        );
    }
}

export default Messages
